import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateControleServicosColumnDefinition
 */

type Props = {
  obraStatus: number | null;
  onActionDeletar: (idObraServicosControlados: number | null, openState: boolean) => void;
};

export const GenerateControleServicosColumnDefinition = ({ obraStatus, onActionDeletar }: Props): GridColDef[] => {
  return [
    {
      field: "nroServico",
      filterable: false,
      headerName: "Nº",
      minWidth: 50,
      sortable: false,
      headerClassName: "descricao-header",
    },
    {
      field: "servicosControlados",
      filterable: false,
      headerName: "Serviço",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: "descricao-header",
    },
    {
      field: "idObraServicosControlados",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          {obraStatus === 0 && (
            <IconButton
              aria-label="Excluir serviço controlado"
              onClick={() => onActionDeletar(params.row.idObraServicosControlados, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          )}
        </div>
      ),
    },
  ];
};
